import HotDrop from './HotDrop';

export default HotDrop;
